const BUYER_SCHEDULE_DEMO_URL = `https://meetings.hubspot.com/mario322?subject=${encodeURIComponent(
  'Parts Hub Pro'
)}`
const DEALER_SCHEDULE_DEMO_URL = `https://meetings.hubspot.com/mario322?subject=${encodeURIComponent(
  'Sales Hub Pro'
)}`

export default { BUYER_SCHEDULE_DEMO_URL, DEALER_SCHEDULE_DEMO_URL }
